const JSON_DATA_BASE_URL = 'https://qa-si-api.sonyliv.com/si-spn-ems-api/api'
const JSON_IMAGE_BASE_URL = 'https://prod-si-feed-api.s3.ap-south-1.amazonaws.com/icon'

export {
    JSON_DATA_BASE_URL,
    JSON_IMAGE_BASE_URL
}